import { shallowEqual, useSelector } from 'react-redux';
import { getAppConfig, getAuthorizationData, getProfileData } from '../../../redux/selectors';
var useAlerts = function () {
    var _a, _b, _c, _d;
    var appConfig = useSelector(getAppConfig, shallowEqual);
    var profileData = useSelector(getProfileData, shallowEqual);
    var alertsData = useSelector(getAuthorizationData, shallowEqual);
    var accountId = (_b = (_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.accountsInfo) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.accountId;
    var hasAccountsData = ((_c = appConfig === null || appConfig === void 0 ? void 0 : appConfig.accountsInfo) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
        !((_d = appConfig === null || appConfig === void 0 ? void 0 : appConfig.accountsInfo) === null || _d === void 0 ? void 0 : _d.some(function (data) { return !data; })) &&
        (appConfig === null || appConfig === void 0 ? void 0 : appConfig.hasAccountsDataLoaded);
    return {
        appConfig: appConfig,
        profileData: profileData,
        isAuthorized: alertsData === null || alertsData === void 0 ? void 0 : alertsData.isAuthorized,
        errorCode: alertsData === null || alertsData === void 0 ? void 0 : alertsData.errorCode,
        syfIdentifier: alertsData === null || alertsData === void 0 ? void 0 : alertsData.syfIdentifier,
        accountsInfo: appConfig === null || appConfig === void 0 ? void 0 : appConfig.accountsInfo,
        accountId: accountId,
        hasAccountsData: hasAccountsData
    };
};
export default useAlerts;
